import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const WALKTHROUGHS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('WALKTHROUGHS');
export const WALKTHROUGHS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WALKTHROUGHS_CRUD_ACTION_CONSTANTS
);
